// extracted by mini-css-extract-plugin
export default {"zoomModal":"A1-z","image":"B1-z","button":"C1-z","isOverlayShown":"D1-z"};